export default __webpack_public_path__ + "static/media/content-library.01960371.svg";